import React from 'react';
import {useCurrentAuthTokens} from '../../services';
import {hasValidOrRefreshableTokens} from '../../services/auth/functions';

export const Authenticated: React.FC = ({children}) => {
  const tokens = useCurrentAuthTokens();
  return hasValidOrRefreshableTokens(tokens) ? <>{children}</> : null;
};
